module.exports = __webpack_public_path__ + "static/media/logo-tp-white.7358bdeb.svg";